module.exports = __webpack_public_path__ + "img/n3.d1551086.png";